import * as annotation from './annotation';
import * as dataset from './dataset';

export default { ...annotation, ...dataset };
